/* eslint-disable max-len */
import styled from 'styled-components';
import { up, down } from 'styled-breakpoints';

export const PERSISTENT_UPGRADE_BANNER_HEIGHT = '3.125rem';

export const PersistentUpgradeContainer = styled.div`
  width: 100vw;
  height: ${PERSISTENT_UPGRADE_BANNER_HEIGHT};
  padding: 20px;
  position: fixed;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  background-image: url('https://stuff.fendergarage.com/images/C/C/9/freemium_persistent_cta_halftone_pattern-desktop-20201009_133146.png'),
    linear-gradient(90deg, #c7294d, #411888);
  z-index: 99;
`;

export const HeadingLine = styled.span`
  display: block;

  ${up('tablet-portrait')} {
    display: inline;
  }

  ${down('phone')} {
    letter-spacing: -0.02em; /* Fix for 320-323px screens */
  }
`;

export const TimeLeftSpan = styled.span`
  font-style: oblique;
  font-family: ${({ theme: { fonts } }): string => fonts.futuraHeavy};
`;

export const ButtonContainer = styled.div`
  white-space: nowrap;

  button {
    color: rgb(28, 23, 118);
    height: 1.875rem;
    width: 6.9375rem;
    box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.4);

    ${up('tablet-portrait')} {
      width: 9.9375rem;
    }
  }
`;
